import React from 'react';
import { Button, Icon, Message } from 'antd';
import account from '@/common/account/index';

const UploadImg2base64 = ({ onFileReady }) => {
  const handleFileChange = (event) => {
    const file = event.files[0];
    if (file.size > 2048000) {
      Message.error('请上传小于2M的文件');
      return;
    }
    const fr = new FileReader();
    fr.onload = (f) => {
      onFileReady(f.target.result);
    };
    fr.readAsDataURL(file);
  };

  const handleUploadImg = () => {
    const loginEd = account.hasLoggedin();
    if (!loginEd) {
      window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
      return;
    }
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = () => {
      handleFileChange(input);
    };
    input.click();
  };

  return (
    <Button type="primary" onClick={handleUploadImg}>
      <Icon type="upload" />
      本地上传
    </Button>
  );
};

export default UploadImg2base64;
